<template>
    <Dialog ref="dialog" :config="config" :beforeClose="beforeClose" :visible='visible' :cancelDialog="cancelDialog" :confirmDialog='confirmDialog' :isdeling='isdeling'>
        <p class="title">您将要删除以下账套：{{rowData.name}}</p>
        <p class="text">账套启用年月：{{rowData.year}}年{{rowData.month}}月</p>
        <p class="text">
           注意：如需保存账套数据，请先备份下载到本地保存。被删除的账套将不再显示。如有需要，您可以在回收站重新还原账套。
        </p>
    </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog";
export default {
  props: {
    rowData:{
      type: Object,
    },
    type:{
      type: String,
    },
    visible: {
      type: Boolean,
    },
    isdeling: {
      type: Boolean,
    },
    cancelDialog:{
      type: Function,
      default: () => {},
    },
    confirmDialog:{
      type: Function,
      default: () => {},
    }
  },
  components: {
    Dialog,
  },
  data() {
    return {
      config: {
        top: '20vh',
        width: '21rem',
        title: '删除账套',
        center: true,
        btnTxt: ['删除','取消'],
      },
    };
  },
  methods: {
    beforeClose(){
      console.log('关闭前');
    },
  }
};
</script>

<style lang="less" scoped>
  .title{
    color: #FF0000;
    font-size: 16px;
  }
  .text{
    color: #333333;
    font-size: 14px;
    margin: 6px 0;
  }
</style>